import { useLang } from "../contexts/LangContext";
import { Globe } from "lucide-react";
import { useState, useRef, useEffect } from "react";

const LANGS = [
  { code: "de", label: "Deutsch" },
  { code: "en", label: "English" },
  { code: "ar", label: "العربية" }
];

export default function LanguageSwitcher() {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(o => !o)}
        className="inline-flex items-center gap-2 px-3 py-2 text-sm font-semibold border border-neutral-300 hover:border-neutral-900 transition-colors rounded-sm uppercase tracking-wider"
        data-testid="lang-switcher-btn"
      >
        <Globe size={16} />
        {lang.toUpperCase()}
      </button>
      {open && (
        <div className="absolute end-0 mt-2 w-40 bg-white border border-neutral-200 shadow-lg z-50">
          {LANGS.map(l => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full text-start px-4 py-2 text-sm hover:bg-neutral-100 ${lang === l.code ? "bg-neutral-50 font-bold" : ""}`}
              data-testid={`lang-option-${l.code}`}
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
